var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBuilding3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.11 5.41-4-2.67c-.67-.45-1.55-.45-2.22 0l-4 2.67C3.34 5.78 3 6.4 3 7.07v5.68c0 .28.22.5.5.5h11c.28 0 .5-.22.5-.5V7.07c0-.67-.33-1.29-.89-1.66zM7.25 9c0-.96.79-1.75 1.75-1.75s1.75.79 1.75 1.75-.79 1.75-1.75 1.75S7.25 9.96 7.25 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73 21.251v-3c.95-.31 1.64-1.2 1.64-2.25v-2c0-1.31-1.07-2.38-2.38-2.38-1.31 0-2.38 1.07-2.38 2.38v2c0 1.04.68 1.92 1.61 2.24v3.01H15v-6c0-.28-.22-.5-.5-.5h-11c-.28 0-.5.22-.5.5v6H2c-.41 0-.75.34-.75.75s.34.75.75.75h17.93c.02 0 .03.01.05.01.02 0 .03-.01.05-.01H22c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-1.27zM9 17.501c.41 0 .75.34.75.75v3h-1.5v-3c0-.41.34-.75.75-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBuilding3);
export default __webpack_public_path__ + "static/media/vuesax-bold-building-3.05dfdda51a095914f543d24c45919f1f.svg";
export { ForwardRef as ReactComponent };